import React, { useState, useRef, useEffect, useMemo } from "react"
import {
  CardBody,
  Col,
  Container,
  Row,
  // Dropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
} from "reactstrap"
import { Dropdown } from "primereact/dropdown"
import { Sidebar } from "primereact/sidebar"
import { Dialog } from 'primereact/dialog'
import { Link, useLocation } from "react-router-dom"
import { Button } from "primereact/button"
import WorkType1 from "pms/common-for-all/WorkTypeOne"
import WorkType from "../common-for-all/WorkType"
import AddProjectDetails from "pms/common-for-all/AddProjectDetails"
import { InputText } from "primereact/inputtext"
import { Calendar } from "primereact/calendar"
import { getCookie } from "../../helpers/cookie"
import axios from "axios"
import { Checkbox } from "primereact/checkbox"
import { Toast } from "primereact/toast"
import { useDispatch } from "react-redux"
import { NOTIFICATION_API_STATUS_FALSE, NOTIFICATION_API_STATUS_TRUE, SET_API_STATUS_FALSE, SET_API_STATUS_TRUE } from "../../store/calendar/actionTypes"
import { MultiSelect } from "primereact/multiselect"
import { FileUpload } from "primereact/fileupload"
import { InputTextarea } from "primereact/inputtextarea"
import { getCompanies } from "../../helpers/backend-helper"
const WorkTypeSidebar = ({ id }) => {
  const dispatch = useDispatch()
  const fileUploadRef = useRef(null)

  const token = getCookie('access_token');
  const [taskdescription, setTaskdescription] = useState("")
  const [taskName, setTaskName] = useState("")
  const [tasksData, setTasksData] = useState([])
  const toast = useRef(null)
  const [statusDescription, setStatusDescription] = useState('');
  const [Watchers, setWatchers] = useState([])
  const getWorktypes = async () => {

    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/worktypes/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.results;
        if (Array.isArray(results)) {
          const mapped = results.map(item => ({
            task_code: item.code || item.task_code || item.id,
            task_type: item.work_type_name || item.task_type || '',
            task_name: item.summary || item.task_name || item.title || '',
            project_name: item.project_name || (item.project && item.project.name) || '',
            assigned_to: item.assigned_to_employee_name || item.assigned_to || (item.assigned_to && item.assigned_to.name) || null,
            task_status: item.work_type_status_name || item.task_status || item.status || '',
            priority: item.priority || '',
            start_date: item.start_date || '',
            end_date: item.end_date || '',
            // keep raw item for detail view
            _raw: item
          }))
          setTasksData(mapped)

        } else {
          if (Array.isArray(response.data)) {
            const mapped = response.data.map(item => ({
              task_code: item.code || item.task_code || item.id,
              task_type: item.work_type_name || item.task_type || '',
              task_name: item.summary || item.task_name || item.title || '',
              project_name: item.project_name || (item.project && item.project.name) || '',
              assigned_to: item.assigned_to_employee_name || item.assigned_to || (item.assigned_to && item.assigned_to.name) || null,
              task_status: item.work_type_status_name || item.task_status || item.status || '',
              priority: item.priority || '',
              start_date: item.start_date || '',
              end_date: item.end_date || '',
              _raw: item
            }))
            setTasksData(mapped)
            console.log('Loaded worktypes (direct array):', mapped.length)
          } else {
            console.warn('Unexpected worktypes payload', response.data)
          }
        }
      }
    } catch (error) {
      console.error('Failed to load worktypes', error)

    }
  };
  const getwatchers = async (projectId) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setWatchers(response.data?.results);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  useEffect(() => {
    getWorktypes()
    getwatchers()
  }, [])
  const [selectedSingle, setselectedSingle] = useState([])
  const [selectedPriority, setSelectedPriority] = useState(null)
  console.log("selectedPriority", selectedPriority);

  const [priorityOptions, setpriorityOptions] = useState([])
  const [statusOptions, setstatusOptions] = useState([])
  const [selectedStatus, setSelectedStatus] = useState([])
  const [ProjectData, setProjectData] = useState([])
  const [selectedProject, setselectedProject] = useState([])
  const [ModuleData, setModuleData] = useState([])
  const [selectedModule, setselectedModule] = useState([])
  const [selectedManager, setselectedManager] = useState('')
  const [WorkType, setWorkType] = useState([])
  const [selectedWorkType, setselectedWorkType] = useState([])
  const selectedValue = WorkType.find((item) => item.id === selectedWorkType)?.value;
  const [statusModalVisible, setStatusModalVisible] = useState(false)
  const [statusModalContext, setStatusModalContext] = useState('priority')
  const [statusForm, setStatusForm] = useState('')
  const [editingStatus, setEditingStatus] = useState(false)
  const [selectedEditdrop, setSelectedEditdrop] = useState(null)
  const [selecteddropoptions, setselecteddropoptions] = useState([])
  const [lastSelectedModuleId, setLastSelectedModuleId] = useState(null);
  const [lastSelectedPriorityId, setLastSelectedPriorityId] = useState(null);
  const [lastSelectedWorkTypeEntityId, setLastSelectedWorkTypeEntityId] = useState(null);
  const [lastSelectedWorkTypeStatusId, setLastSelectedWorkTypeStatusId] = useState(null);
  const [lastSelectedApprovalId, setLastSelectedApprovalId] = useState(null);
  const [Employees, setEmployees] = useState([])
  const [selectedEmployee, setselectedEmployee] = useState([])
  const [selectedAssignedBy, setSelectedAssignedBy] = useState('')
  const [selectedCompanyAssignedBy, setSelectedCompanyAssignedBy] = useState('')
  const [assignedByOptions, setAssignedByOptions] = useState([])
  const [PrivateDropdownValues, setPrivateDropdownValues] = useState([])
  const [selectedWatcher, setselectedWatcher] = useState([])
  const [worktypestatus, setWorkTypeStatus] = useState([])
  const [selectedWorkTypeStatus, setselectedWorkTypeStatus] = useState([])
  const [WorkHours, setWorkHours] = useState('')
  const [createFirst, setCreateFirst] = useState("")
  const [jobStartDate, setJobStartDate] = useState(null)
  const [jobEndDate, setJobEndDate] = useState(null)
  const [jobActualDate, setjobActualDate] = useState(null)
  const [selectedTask, setSelectedTask] = useState(null)
  // Notes for selected worktype
  const [isEditorVisible, setEditorVisible] = useState(false)
  const [editorContent, setEditorContent] = useState('')
  const [editIndex, setEditIndex] = useState(null)
  const [taskNotes, setTaskNotes] = useState([])
  const [compamyitem, setcompamyitem] = useState([])

  const getCompanydata = async () => {
    try {
      const response = await getCompanies();
      // normalize possible response shapes
      let items = []
      if (Array.isArray(response)) items = response
      else if (response && Array.isArray(response.results)) items = response.results
      else if (response && Array.isArray(response.data)) items = response.data

      // map companies to a consistent shape used by the UI
      const mapped = items.map(c => ({
        id: c.id || c.pk || c.company_id,
        name: c.name || c.company_name || c.title || "",
        code: c.code || c.company_code || null,
        label: c.name || c.company_name || c.title || "",
        value: c.id || c.pk || c.company_id || c.name || null,
        __raw: c,
      }))

      setcompamyitem(mapped);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  }
  useEffect(() => {
    getCompanydata()
  }, [])
  const [emploader, setemploader] = useState(false)
  const getdeliveryManager = async (companyId) => {
    try {
      setemploader(true)
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?company=${companyId}&status=Active`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setAssignedByOptions(response.data.results);
      setemploader(false)
    } catch (err) {
      console.log("Error fetching categories:", err);
      setemploader(false)
    }
  }
  const getSingleWorkType = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/projects/${id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        const data = response.data;
        setselectedProject(data.name || null);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getProject = async (id) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/projects/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        setProjectData(response.data.results)
      }
    } catch (err) {
      console.log(err);

    }
  }
  const getModules = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/modules/?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
         let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
        setModuleData(tasksStatus);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  const getWorkType = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=work_type`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setWorkType(response.data?.results?.results);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
 const getWorkTypeStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/task-status/?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;
        setWorkTypeStatus(tasksStatus);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  const getPrivateOptions = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_Company_Contact}/company/private-users/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        let results = response.data.data;
        console.log(results, 'results');
        const options = results.map((category) => ({
          name: category.name
            .replace(/_/g, ' ')
            .replace(/\b\w/g, (char) => char.toUpperCase()),
          value: category.id,
        }));
        setPrivateDropdownValues(options);
      }
    } catch (error) {

    }
  };
  const getPriorityOptions = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/lookups/?name=priority`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const results = response.data?.results?.results || response.data?.results || [];

        const mapped = results.map((item) => ({
          name: item.value,
          code: item.id
        }));

        setpriorityOptions(mapped);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  const getEmployees = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?project_team=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setEmployees(response.data?.results);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  const getApprovalStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/approval-status/?project_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
       let tasksStatus = response.data.results || response.data || response.data.data || response.data.data.results;

        // const mapped = results.map((item) => ({
        //   name: item.value,
        //   code: item.id
        // }));

        setstatusOptions(tasksStatus);
      }
    } catch (err) {
      console.error("Failed to load modules:", err);
    }
  };
  const [selectedCompanies, setSelectedCompanies] = useState([]);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [companyDropdownData, setCompanyDropdownData] = useState({})
  const getTeam = async (company) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_Company_Contact}/company/employees/?company_id=${company}&is_active=true`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        return Array.isArray(response.data?.results) ? response.data?.results : [];
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleCompanySelect = async (e, companyId) => {
    if (e.target.checked) {
      setSelectedCompanies(prev => [...prev, companyId]);
      const data = await getTeam(companyId);
      setCompanyDropdownData(prev => ({
        ...prev,
        [companyId]: data
      }));
    } else {
      setSelectedCompanies(prev => prev.filter(id => id !== companyId));
      setCompanyDropdownData(prev => {
        const updated = { ...prev };
        delete updated[companyId];
        return updated;
      });
    }
  };
  const handleMultiSelectChange = (companyId, e) => {
    const selectedIds = e.value;

    setCompanyDropdownData(prev => {
      const updated = {
        ...prev,
        [companyId]: {
          ...prev[companyId],
          selected: selectedIds,
        }
      };

      // NOW updated has the latest values
      const finalPayload = Object.entries(updated).map(([id, data]) => ({
        company_id: Number(id),
        employee_ids: data.selected
      }));

      console.log(finalPayload, "finalPayload");
      const allEmployeeIds = finalPayload.flatMap(item => item.employee_ids);

      setSelectedWatchersids(allEmployeeIds);
      return updated;
    });
  };


  const getCompanyData = async () => {
    try {
      const response = await getCompanies();

      if (response && response.results) {
        const transformedCompanies = response.results.map((company, index) => ({
          name: company.name || company.company_name,
          color: "#000000",
          id: String(company.id || `company-${index}`),
          __original: company
        }));
        const parentCompany = response.results.find(
          (c) => c.is_parent_company === true
        );
        setCompanyOptions(transformedCompanies);
        // setSelectedCompany(parentCompany ? String(parentCompany.id) : null);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };
  useEffect(() => {
    getCompanyData();
  }, []);
  useEffect(() => {
    getCompanyData()
    getProject()
    getModules()
    getApprovalStatus(id)
    // getWorkType()
    // getPriorityOptions()
    getEmployees()
    getWorkTypeStatus(id)
    // getPrivateOptions()
    getSingleWorkType()
  }, [])

  useEffect(() => {
    if (statusModalContext === 'work_type_entity') setselecteddropoptions(WorkType || [])
    else if (statusModalContext === 'priority') setselecteddropoptions(priorityOptions || [])
    else if (statusModalContext === 'work_type_status') setselecteddropoptions(worktypestatus || [])
    else if (statusModalContext === 'work_type_module') setselecteddropoptions(ModuleData || [])
    else if (statusModalContext === 'approval') setselecteddropoptions(statusOptions || [])
    else setselecteddropoptions(priorityOptions || [])
  }, [statusModalContext, worktypestatus, WorkType, priorityOptions, statusOptions])

  useEffect(() => {
    if (selectedWorkType && selectedWorkType !== 'add' && selectedWorkType !== 'edit') {
      setLastSelectedWorkTypeEntityId(selectedWorkType)
    }

    if (selectedWorkType === 'add') {
      setStatusModalVisible(true)
      setStatusForm('')
      setEditingStatus(false)
      setStatusModalContext('work_type_entity')
      setselectedWorkType(null)
    } else if (selectedWorkType === 'edit') {
      if (lastSelectedWorkTypeEntityId) {
        setEditingStatus(true)
        const current = WorkType?.find(opt => opt.id === lastSelectedWorkTypeEntityId)
        setStatusForm(current?.value || current?.name || '')
        setStatusModalVisible(true)
        setStatusModalContext('work_type_entity')
        setselectedWorkType(lastSelectedWorkTypeEntityId)
        setSelectedEditdrop(lastSelectedWorkTypeEntityId)
      } else {
        console.warn('No work type selected to edit!')
      }
    }
  }, [selectedWorkType, lastSelectedWorkTypeEntityId, WorkType])

  useEffect(() => {
    if (selectedPriority && selectedPriority !== 'add' && selectedPriority !== 'edit') {
      setLastSelectedPriorityId(selectedPriority)
    }

    if (selectedPriority === 'add') {
      setStatusModalVisible(true)
      setStatusForm('')
      setEditingStatus(false)
      setStatusModalContext('priority')
      setSelectedPriority(null)
    } else if (selectedPriority === 'edit') {
      if (lastSelectedPriorityId) {
        setEditingStatus(true)
        const current = priorityOptions?.find(opt => opt.code === lastSelectedPriorityId)
        setStatusForm(current?.name || current?.value || '')
        setStatusModalVisible(true)
        setStatusModalContext('priority')
        setSelectedPriority(lastSelectedPriorityId)
        setSelectedEditdrop(lastSelectedPriorityId)
      } else {
        console.warn('No priority selected to edit!')
      }
    }
  }, [selectedPriority, lastSelectedPriorityId, priorityOptions])

  useEffect(() => {
    if (selectedWorkTypeStatus && selectedWorkTypeStatus !== 'add' && selectedWorkTypeStatus !== 'edit') {
      setLastSelectedWorkTypeStatusId(selectedWorkTypeStatus)
    }

    if (selectedWorkTypeStatus === 'add') {
      setStatusModalVisible(true)
      setStatusForm('')
      setEditingStatus(false)
      setStatusModalContext('work_type_status')
      setselectedWorkTypeStatus(null)
    } else if (selectedWorkTypeStatus === 'edit') {
      if (lastSelectedWorkTypeStatusId) {
        setEditingStatus(true)
        const current = worktypestatus?.find(opt => opt.id === lastSelectedWorkTypeStatusId)
        setStatusForm(current?.value || current?.name || '')
        setStatusModalVisible(true)
        setStatusModalContext('work_type_status')
        setselectedWorkTypeStatus(lastSelectedWorkTypeStatusId)
        setSelectedEditdrop(lastSelectedWorkTypeStatusId)
      } else {
        console.warn('No work type status selected to edit!')
      }
    }
  }, [selectedWorkTypeStatus, lastSelectedWorkTypeStatusId, worktypestatus])

  useEffect(() => {
    if (selectedStatus && selectedStatus !== 'add' && selectedStatus !== 'edit') {
      setLastSelectedApprovalId(selectedStatus)
    }

    if (selectedStatus === 'add') {
      setStatusModalVisible(true)
      setStatusForm('')
      setEditingStatus(false)
      setStatusModalContext('approval')
      setSelectedStatus(null)
    } else if (selectedStatus === 'edit') {
      if (lastSelectedApprovalId) {
        setEditingStatus(true)
        const current = statusOptions?.find(opt => opt.id === lastSelectedApprovalId)
        setStatusForm(current?.value || current?.name || '')
        setStatusModalVisible(true)
        setStatusModalContext('approval')
        setSelectedStatus(lastSelectedApprovalId)
        setSelectedEditdrop(lastSelectedApprovalId)
      } else {
        console.warn('No approval status selected to edit!')
      }
    }
  }, [selectedStatus, lastSelectedApprovalId, statusOptions])


  useEffect(() => {
    if (selectedModule && selectedModule !== 'add' && selectedModule !== 'edit') {
      setLastSelectedModuleId(selectedModule)
    }

    if (selectedModule === 'add') {
      setStatusModalVisible(true)
      setStatusForm('')
      setEditingStatus(false)
      setStatusModalContext('work_type_module')
      setselectedModule(null)
    } else if (selectedModule === 'edit') {
      if (lastSelectedModuleId) {
        setEditingStatus(true)
        const current = ModuleData?.find(opt => opt.id === lastSelectedModuleId)
        setStatusForm(current?.value || current?.name || '')
        setStatusModalVisible(true)
        setStatusModalContext('work_type_module')
        setselectedModule(lastSelectedModuleId)
        setSelectedEditdrop(lastSelectedModuleId)
      } else {
        console.warn('No module selected to edit!')
      }
    }
  }, [selectedModule, lastSelectedModuleId, ModuleData])

  const handlePrioritySave = async () => {
    try {
      if (statusForm?.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty', life: 3000 });
        return
      }
      const body = { name: 'priority', value: statusForm, description: statusDescription ? statusDescription : statusForm, type: 'company' }
      if (editingStatus && lastSelectedPriorityId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedPriorityId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
      }
      setStatusModalVisible(false)
      setEditingStatus(false)
      setStatusForm('')
      setSelectedPriority(null)
      getPriorityOptions()
    } catch (err) {
      console.error(err)
    }
  }

  const handleWorkTypeSave = async () => {
    try {
      if (statusForm?.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty', life: 3000 });
        return
      }
      const body = { name: 'work_type', value: statusForm, description: statusForm, type: 'company' }
      if (editingStatus && lastSelectedWorkTypeEntityId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedWorkTypeEntityId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
      }
      setStatusModalVisible(false)
      setEditingStatus(false)
      setStatusForm('')
      setselectedWorkType(null)
      getWorkType()
    } catch (err) {
      console.error(err)
    }
  }

  const handleApprovalSave = async () => {
    try {
      if (statusForm?.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty', life: 3000 });
        return
      }
      const body = { name: 'approval_status', value: statusForm, description: statusForm, type: 'company' }
      if (editingStatus && lastSelectedApprovalId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedApprovalId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
      }
      setStatusModalVisible(false)
      setEditingStatus(false)
      setStatusForm('')
      setSelectedStatus(null)
      getApprovalStatus()
    } catch (err) {
      console.error(err)
    }
  }

  const handleWorkTypeStatusSave = async () => {
    try {
      if (statusForm?.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty', life: 3000 });
        return
      }
      const body = { name: 'work_type_status', value: statusForm, description: statusForm, type: 'company' }
      if (editingStatus && lastSelectedWorkTypeStatusId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedWorkTypeStatusId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
      }
      setStatusModalVisible(false)
      setEditingStatus(false)
      setStatusForm('')
      setselectedWorkTypeStatus(null)
      getWorkTypeStatus()
    } catch (err) {
      console.error(err)
    }
  }

  const handleModuleSave = async () => {
    try {
      if (statusForm?.trim() === '') {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Value cannot be empty', life: 3000 });
        return
      }
      const body = { name: 'work_type_module', value: statusForm, description: statusDescription || statusForm, type: 'company' }
      if (editingStatus && lastSelectedModuleId) {
        await axios.patch(`${process.env.REACT_APP_Company_Contact}/company/lookups/${lastSelectedModuleId}/`, body, { headers: { Authorization: `Bearer ${token}` } })
      } else {
        await axios.post(`${process.env.REACT_APP_Company_Contact}/company/lookups/`, body, { headers: { Authorization: `Bearer ${token}` } })
      }
      setStatusModalVisible(false)
      setEditingStatus(false)
      setStatusForm('')
      setselectedModule(null)
      getModules()
    } catch (err) {
      console.error(err)
    }
  }

  const handleModalSave = async () => {
    try {
      if (statusModalContext === 'priority') await handlePrioritySave()
      else if (statusModalContext === 'work_type_entity') await handleWorkTypeSave()
      else if (statusModalContext === 'approval') await handleApprovalSave()
      else if (statusModalContext === 'work_type_status') await handleWorkTypeStatusSave()
      else if (statusModalContext === 'work_type_module') await handleModuleSave()
    } catch (err) {
      console.error('Error saving modal', err)
    }
  }
  const [footerVisibleColumns, setFooterVisibleColumns] = useState(() => {
    const savedColumns = localStorage.getItem('workTypeSelectedColumns')
    if (savedColumns) {
      try {
        return JSON.parse(savedColumns)
      } catch (error) {
        console.error('Error parsing saved columns:', error)
      }
    }
    return [
      'task_code',
      'task_type',
      'project_name',
      'task_name',
      'assigned_to',
      'task_status',
      'priority'
    ]
  })
  useEffect(() => {
    const handleColumnUpdate = (event) => {
      if (event.detail && event.detail.type === 'COLUMN_SELECTION') {
        setFooterVisibleColumns(event.detail.selectedColumns)
        console.log('WorkTypeAllActive received column update:', event.detail.selectedColumns)
      } else if (event.detail && event.detail.type === 'COLUMN_RESET') {
        setFooterVisibleColumns(event.detail.selectedColumns)
        console.log('WorkTypeAllActive received column reset:', event.detail.selectedColumns)
      } else if (event.detail && event.detail.type === 'COLUMN_LOAD') {
        setFooterVisibleColumns(event.detail.selectedColumns)
        console.log('WorkTypeAllActive received column load:', event.detail.selectedColumns)
      }
    }

    window.addEventListener('footerColumnUpdate', handleColumnUpdate)

    return () => {
      window.removeEventListener('footerColumnUpdate', handleColumnUpdate)
    }
  }, [])

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'workTypeSelectedColumns' && e.newValue) {
        try {
          const newColumns = JSON.parse(e.newValue)
          setFooterVisibleColumns(newColumns)
          console.log('WorkTypeAllActive received storage change:', newColumns)
        } catch (error) {
          console.error('Error parsing storage change:', error)
        }
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [])

  document.title = "PMS | React Admin & Dashboard Template"

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [visibleRight, setVisibleRight] = useState(false)
  const [PoliciesfilesErrorMessagepan, setPoliciesfilesErrorMessagepan] = useState()
  const handleFileUploadChange = (e) => {
    const f = e.target.files && e.target.files[0]
    setUploadedFiles(f)
  }
  const [popchecked2, setPopchecked2] = useState(false)
  const [privateDrop, setPrivateDrop] = useState([])
  const handlePopupCheckbox2 = e => {
    setPopchecked2(e.checked)
    if (!e.checked) {
      setPrivateDrop([])
    }
  }
  const [selectedWatchersids, setSelectedWatchersids] = useState([])
  const [submitloader,setsubmitloader] = useState(false)
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      !selectedProject ||
      // !selectedModule ||
      !selectedAssignedBy ||
      !selectedWorkType ||
      !selectedPriority ||
      !selectedEmployee?.length ||
      !createFirst ||
      !jobStartDate ||
      !jobEndDate ||
      !jobActualDate ||
      !selectedWorkTypeStatus ||
      !selectedStatus ||
      !taskName ||
      taskName?.trim() === '' ||
      !taskdescription ||
      taskdescription?.trim() === '' 
      
    ) {
      toast?.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please fill all mandatory fields',
        life: 3000
      });
      return;
    }
    try {
      setsubmitloader(true)
      const formatDate = (date) => {
        if (!date) return null;
        return new Date(date).toISOString().split("T")[0];
      };
      let assignEmp = []
      const teamMemberMap = selectedEmployee.reduce((acc, id) => {
        const emp = Employees.find(e => e.id === id);
        acc[id] = emp?.project_membership?.team_member_id || null;
        return acc;
      }, {});
      Object.values(teamMemberMap).forEach(id => {
        if (id) assignEmp.push(id);
      });
      const payload = new FormData();
      payload.append("project", id);
      payload.append("module", selectedModule);
      payload.append("work_type", selectedWorkType);
      // payload.append("parent_work_type", formData.parentWorkType);
      payload.append("summary", taskdescription);
      payload.append("task_name", taskName);
      payload.append("priority", selectedPriority);
      if (selectedEmployee) payload.append("assigned_to", assignEmp);
      // payload.append("watcher", selectedWatcher);
      payload.append("assigned_by", selectedAssignedBy);
      payload.append("watcher_ids", selectedWatchersids);
      payload.append("work_hours", createFirst);
      payload.append("start_date", formatDate(jobStartDate));
      payload.append("end_date", formatDate(jobEndDate));
      payload.append("actual_end_date", formatDate(jobActualDate));
      payload.append("work_type_status", selectedWorkTypeStatus);
      payload.append("approval_status", selectedStatus);
      // payload.append('is_private', privateDrop)
      // if (uploadedFiles) payload.append('file', uploadedFiles)  
      if (uploadedFiles && uploadedFiles.length > 0) {
        uploadedFiles.forEach((file) => {
          payload.append("files", file);
        });
      }
      // if (formData.attachments?.length > 0) {
      //   Array.from(formData.attachments).forEach((file) => {
      //     payload.append("attachments", file);
      //   });
      // }

      const response = await axios.post(
        `${process.env.REACT_APP_Company_Contact}/company/worktypes/`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data"
          }
        }
      );

      if (response.status === 201 || response.status === 200) {
        console.log("Work type created:", response.data);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: "Work type created successfully",
          life: 3000
        });
      setsubmitloader(false)
        setVisibleRight(false);
        getWorktypes()
        dispatch({ type: SET_API_STATUS_TRUE })
        dispatch({type:NOTIFICATION_API_STATUS_TRUE})
        setTimeout(() => {
          dispatch({ type: SET_API_STATUS_FALSE })
        dispatch({type:NOTIFICATION_API_STATUS_FALSE})

        }, 2000)
        
      }
    } catch (error) {
      console.error("Error creating work type:", error);
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message || "Failed to create work type",
        life: 3000
      });
      setsubmitloader(false)
    }
  };
  const PRIORITY_CHOICES = [
    { value: 'HIGH', name: 'High' },
    { value: 'MEDIUM', name: 'Medium' },
    { value: 'LOW', name: 'Low' },
  ]
  return (
    <div>

      <button
        type="button"
        className="btn btn-secondary import-res-btn md:w-10rem me-1"
        onClick={() => {
          setVisibleRight(true)
        }}
      >
        Add Task
      </button>
      <Toast ref={toast} />
      <Row>
        {submitloader ?
              <div
                style={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backdropFilter: "blur(1px)",  // 💥 BLUR BACKGROUND
                  backgroundColor: "rgba(255, 255, 255, 0.4)", // soft overlay
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 9999
                }}
              >
                <div
                  style={{
                    width: "45px",
                    height: "45px",
                    border: "4px solid #ddd",
                    borderTopColor: "#126fa9",
                    borderRadius: "50%",
                    animation: "spin 0.8s linear infinite"
                  }}
                ></div>
              </div> : ""
            }
        <Col lg={12}>
          <Sidebar
            visible={visibleRight}
            position="right"
            onHide={() => setVisibleRight(false)}
            className="sidebar"
          >
            <div className="sidebar-header">
              <h3>Create a Task</h3>
              <div className="d-flex align-items-center">
                <Link to={`/worktype-editform?id=${id}`} className="me-3" title="Edit Project">
                  <p className="mb-0 text-white">
                    {" "}
                    <i class="fa-regular fa-pen-to-square me-3"></i>{" "}
                  </p>
                </Link>
                <Button
                  icon="pi pi-times"
                  className="p-button-text close-btn"
                  onClick={() => setVisibleRight(false)}
                />
              </div>
            </div>
            {/* Shared modal for adding/editing lookups */}
            <Dialog
              header={
                statusModalContext === 'priority' ? (editingStatus ? 'Edit Priority' : 'Add Priority') :
                  statusModalContext === 'work_type_entity' ? (editingStatus ? 'Edit Work Type' : 'Add Work Type') :
                    statusModalContext === 'approval' ? (editingStatus ? 'Edit Approval Status' : 'Add Approval Status') :
                      statusModalContext === 'work_type_status' ? (editingStatus ? 'Edit Work Type Status' : 'Add Work Type Status') :
                        (editingStatus ? 'Edit' : 'Add')
              }
              visible={statusModalVisible}
              onHide={() => setStatusModalVisible(false)}
              style={{ width: '30vw' }}
              footer={
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                  <Button label={editingStatus ? 'Update' : 'Add'} icon="pi pi-save" className="p-button-primary" onClick={handleModalSave} />
                  <Button label="Cancel" icon="pi pi-times" className="p-button-text" onClick={() => setStatusModalVisible(false)} />
                </div>
              }
            >
              <div className="p-fluid">
                {editingStatus && (
                  <>
                    <label className="mb-1">Select item to edit</label>
                    <Dropdown
                      value={selectedEditdrop}
                      options={selecteddropoptions}
                      onChange={(e) => {
                        const selectedObj = selecteddropoptions.find((opt) => opt[statusModalContext === 'priority' ? 'code' : 'id'] === e.value);
                        setStatusForm(selectedObj ? (statusModalContext === 'priority' ? selectedObj.name : selectedObj.value) : '');
                        setSelectedEditdrop(selectedObj ? (statusModalContext === 'priority' ? selectedObj.code : selectedObj.id) : '');
                      }}
                      placeholder="Select to prefill"
                      className="w-full bgclr mb-2"
                      optionLabel={statusModalContext === 'priority' ? 'name' : 'value'}
                      optionValue={statusModalContext === 'priority' ? 'code' : 'id'}
                      filter
                    />
                  </>
                )}

                <label>{statusModalContext === 'priority' ? 'Priority' : statusModalContext === 'work_type_entity' ? 'Work Type' : statusModalContext === 'approval' ? 'Approval Status' : statusModalContext === 'work_type_status' ? 'Work Type Status' : 'Value'}</label><span style={{ color: "red", marginLeft: "5px" }}>*</span>
                <InputText value={statusForm} onChange={(e) => setStatusForm(e.target.value)} className="mb-2" />
                <label>Description</label>
                <InputTextarea
                  value={statusDescription}
                  onChange={(e) => setStatusDescription(e.target.value)}
                  rows={3}
                  // autoResize
                  className="w-full"
                />
              </div>
            </Dialog>

            <form onSubmit={handleSubmit}>
              <div className="card sidebardetails">
                <Row className="mb-2">
                  <Col lg={6}>
                    <label htmlFor="selectProject" className="block">
                      Project
                    </label>
                    <InputText value={selectedProject} readOnly />
                  </Col>
                  <Col lg={6}>
                    <label htmlFor="city" className="mb-1">
                      Select Module
                    </label>
                     <Dropdown
                                          id="project"
                                          value={selectedModule}
                                          onChange={(e) => setselectedModule(e.value)}
                                          options={ModuleData}
                                          // options={[
                                          //   ...ModuleData,
                                          //   { id: "add", value: "Add New", icon: "pi pi-plus" },
                                          //   ...(selectedModule ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                                          // ]}
                                          placeholder="Select Module"
                                          className="w-full bgclr"
                                          optionLabel="name"
                                          optionValue="id"
                                          filter
                                          // itemTemplate={(option) => (
                                          //   <div className="flex align-items-center gap-2">
                                          //     {option?.icon && <i className={option.icon}></i>}
                                          //     <span>{option.value}</span>
                                          //   </div>
                                          // )}
                                        />
                  </Col>
                </Row>
                {/* <Row className="mb-2 mt-3">
                  <Col lg={6} className="mt-2">

                    <label htmlFor="jobType" className="block">
                      Work Type
                    </label>
                    <Dropdown
                      id="project"
                      value={selectedWorkType}
                      onChange={(e) => setselectedWorkType(e.value)}
                      options={[
                        ...WorkType,
                        { id: "add", value: "Add New", icon: "pi pi-plus" },
                        ...(selectedWorkType ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                      ]}
                      placeholder="Select Work Type"
                      className="w-full bgclr"
                      optionLabel="value"
                      optionValue="id"
                      filter
                      itemTemplate={(option) => (
                        <div className="flex align-items-center gap-2">
                          {option?.icon && <i className={option.icon}></i>}
                          <span>{option.value}</span>
                        </div>
                      )}
                    />
                  </Col>

                  {selectedValue === "Sub Task" && <Col lg={6}>

                    <label htmlFor="job" className="block mb-1 mt-2">
                      Parent Work Type
                    </label>
                    <AddProjectDetails />
                  </Col>
                  }
                </Row> */}
                <Row className="mt-3">
                  <Col lg={6} className="mt-2">
                    <label htmlFor="city" className="mb-1">
                      Task Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputText
                      placeholder="Task Name"
                      value={taskName}
                      onChange={(e) => setTaskName(e.target.value)}
                    />
                  </Col>
                  <Col lg={6} className="mt-2">
                    <label htmlFor="city" className="mb-1">
                      Task Description <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputText
                      placeholder="Task Description"
                      value={taskdescription}
                      onChange={(e) => setTaskdescription(e.target.value)}
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col lg={6} className="mb-2">
                    <label htmlFor="city" className="mb-0 mt-2">
                      Priority <span style={{ color: "red" }}>*</span>
                    </label>
                    <Dropdown
                      value={selectedPriority}
                      onChange={e => setSelectedPriority(e.target.value)}
                      // options={[
                      //   ...priorityOptions,
                      //   { code: "add", name: "Add New", icon: "pi pi-plus" },
                      //   ...(selectedPriority ? [{ code: "edit", name: "Edit Selected", icon: "pi pi-pencil" }] : []),
                      // ]}
                      options={PRIORITY_CHOICES}
                      optionLabel="name"
                      optionValue="value"
                      placeholder="Select Priority"
                      className="bgclr mt-1"
                    />
                  </Col>

                  <Col lg={6} className="mb-2 mt-2">
                    <label htmlFor="city" className="mb-1">
                      Assigned to <span style={{ color: "red" }}>*</span>
                    </label>
                    <MultiSelect
                      id="assignedTo"
                      value={selectedEmployee}
                      options={Employees}
                      onChange={(e) => setselectedEmployee(e.value)}
                      optionLabel={(option) => `${option.full_name} (${option.company_name})`}
                      optionValue="id"
                      display="chip"
                      filter
                      placeholder="Select Employees"
                      className="w-full"
                    />
                  </Col>
                </Row>
                <Row className="mt-3">
                  <Col lg={6}>
                    <label>Select Company Assigned By <span className="text-danger">*</span></label>
                    <Dropdown
                      value={selectedCompanyAssignedBy}
                      options={compamyitem}
                      onChange={(e) => { getdeliveryManager(e.value); setSelectedCompanyAssignedBy(e.value); }}
                      optionLabel="label"
                      optionValue="id"
                      placeholder="Select Company Assigned By"
                      className="w-full"
                      filter
                    />
                  </Col>
                  <Col lg={6}>
                    <label>Assigned By <span className="text-danger">*</span></label>
                    <Dropdown
                      value={selectedAssignedBy}
                      onChange={e => setSelectedAssignedBy(e.target.value)}
                      options={assignedByOptions}
                      optionValue="id"
                      optionLabel={(option) => `${option.full_name} (${option.primary_email})`}
                      placeholder="Select Assigned By"
                      className="bgclr"
                      filter
                      loading={emploader}
                    />
                  </Col>
                </Row>
                <div className="pt-2 mb-3">
                  <label
                    className="form-label form-field-label formFieldLabel"
                    for=""
                  >
                    Add Watchers
                  </label>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="WatcherBlock pe-3"></div>
                  </div>
                </div>
                {companyOptions.map((company, i) => (
                  <Row className="mb-2" key={i}>
                    <Col lg={6}>
                      <div className="form-check d-flex align-items-center gap-2">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`company_${i}`}
                          checked={selectedCompanies.includes(company.id)}
                          onChange={(e) => handleCompanySelect(e, company.id)}
                        />
                        <label htmlFor={`company_${i}`}>{company.name}</label>
                      </div>
                    </Col>

                    {/* Show dropdown only if company is selected */}
                    {selectedCompanies.includes(company.id) && (
                      <Col lg={6}>
                        <MultiSelect
                          id={`company_multi_${company.id}`}
                          value={companyDropdownData[company.id]?.selected || []}
                          onChange={(e) => handleMultiSelectChange(company.id, e)}
                          options={
                            companyDropdownData[company.id]
                              ? Object.values(companyDropdownData[company.id])
                                .filter(item => item && typeof item === "object" && item.id)
                              : []
                          }


                          optionLabel={(option) => `${option.full_name} (${option.primary_email})`}
                          optionValue="id"
                          display="chip"
                          filter
                          placeholder="Select Employees"
                          className="w-full"
                        />
                      </Col>
                    )}


                  </Row>
                ))}



                <Row className="mb-2 mt-1">
                  {/* <Col lg={6} className="mb-3 mt-2">
                    <label htmlFor="city" className="mb-1">
                      Add Watcher
                    </label>
                    <MultiSelect
                      id="assignedTo"
                      value={selectedWatcher}
                      onChange={(e) => setselectedWatcher(e.value)}
                      options={Watchers}
                      optionLabel={(option) => `${option.full_name} (${option.primary_email})`}
                      optionValue="id"
                      display="chip"
                      filter
                      placeholder="Select Employees"
                      className="w-full"
                    />

                  </Col> */}
                  <Col lg={6} className="mb-3 mt-2">
                    <label htmlFor="city" className="p-mb-2">
                      Work Hours (in hours) <span style={{ color: "red" }}>*</span>
                    </label>
                    <InputText
                      placeholder="Work hours"
                      value={createFirst}
                      onChange={(e) => setCreateFirst(e.target.value)}
                    />
                  </Col>

                </Row>
                <Row className="mb-3">
                  <Col lg={6}>
                    <label htmlFor="jobStartDate" className="p-mb-2">
                      Start Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <Calendar
                      id="jobStartDate"
                      value={jobStartDate}
                      onChange={e => setJobStartDate(e.value)}
                      dateFormat="dd/mm/yy"
                      placeholder="Start Date"
                      className="w-full activejobdrop"
                      showIcon
                    />
                  </Col>
                  <Col lg={6}>
                    <label htmlFor="jobEndDate" className="mr-2">
                      End Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <Calendar
                      id="jobEndDate"
                      value={jobEndDate}
                      onChange={e => setJobEndDate(e.value)}
                      dateFormat="dd/mm/yy"
                      placeholder="End Date"
                      className="w-full activejobdrop"
                      showIcon
                    />
                  </Col>

                </Row>

                <Row className="mb-3 mt-2">
                  <Col lg={6}>
                    <label htmlFor="jobStartDate" className="p-mb-2">
                      Actual End Date <span style={{ color: "red" }}>*</span>
                    </label>
                    <Calendar
                      id="jobStartDate"
                      value={jobActualDate}
                      onChange={e => setjobActualDate(e.value)}
                      dateFormat="dd/mm/yy"
                      placeholder="Actual End Date"
                      className="w-full activejobdrop"
                      showIcon
                    />
                  </Col>
                  <Col lg={6} >
                    <label htmlFor="city" className="p-mb-2">
                      {/* Work Type Status */}
                      Task Status <span style={{ color: "red" }}>*</span>
                    </label>
                    <Dropdown
                      id="project"
                      value={selectedWorkTypeStatus}
                      onChange={(e) => setselectedWorkTypeStatus(e.value)}
                      options={worktypestatus}
                      // options={[
                      //   ...worktypestatus,
                      //   { id: "add", value: "Add New", icon: "pi pi-plus" },
                      //   ...(selectedWorkTypeStatus ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                      // ]}
                      placeholder="Select Work Type Status"
                      className="w-full bgclr"
                      optionLabel="name"
                      optionValue="id"
                      filter
                      itemTemplate={(option) => (
                        <div className="flex align-items-center gap-2">
                          <span style={{color:option.colour}}>{option.name}</span>
                        </div>
                      )}
                    />
                  </Col>
                  <Col lg={6}>
                    <label htmlFor="city" className="mb-1 mt-4">
                      Approval Status <span style={{ color: "red" }}>*</span>
                    </label>
                    <Dropdown
                      id="status"
                      value={selectedStatus}
                      onChange={(e) => setSelectedStatus(e.value)}
                      options={statusOptions}
                      // options={[
                      //   ...statusOptions,
                      //   { id: "add", value: "Add New", icon: "pi pi-plus" },
                      //   ...(selectedStatus ? [{ id: "edit", value: "Edit Selected", icon: "pi pi-pencil" }] : []),
                      // ]}
                      placeholder="Select Approval Status"
                      className="w-full bgclr"
                      optionLabel="name"
                      optionValue="id"
                      filter
                    // itemTemplate={(option) => (
                    //   <div className="flex align-items-center gap-2">
                    //     {option?.icon && <i className={option.icon}></i>}
                    //     <span>{option.value}</span>
                    //   </div>
                    // )}
                    />
                  </Col>
                </Row>

                <Row className="mb-3 mt-2">
                  <Col lg={12}>
                    <label
                      htmlFor="availabilityDate"
                      className="mb-0 avbdate"
                    >
                      Choose/ Drag Attachment
                    </label>

                    {/* <input
                                              type="file"
                                              accept="image/jpg,image/jpeg,image/png,image/pdf"
                                              className="form-control addEmp_ProfilePhoto"
                                              id="MyPro_UploadedProfilePhoto_Modal_FilesInput"
                                              multiple
                                              onChange={handleFileUploadChange} 
                                            /> */}
                    <FileUpload
                      ref={fileUploadRef}
                      name="files[]"
                      accept="image/jpg,image/jpeg,image/png,application/pdf"
                      maxFileSize={1000000}
                      multiple
                      customUpload
                      auto
                      uploadHandler={(e) => {
                        setUploadedFiles(e.files)
                      }}
                      onClear={() => {
                        setUploadedFiles([])
                      }}
                    />
                    <small className="text-danger">
                      {" "}
                      {PoliciesfilesErrorMessagepan}
                    </small>
                    <small className="text-muted">
                      Eg: (jpeg,png,pdf,jpg)
                    </small>
                  </Col>
                </Row>
                {/* <Row className="mb-3 mt-3 justify-content-start align-items-center">
                  <Col lg={2}>
                    <div className="d-flex align-items-center">
                      <Checkbox
                        inputId="checkbox"
                        checked={popchecked2}
                        onChange={handlePopupCheckbox2}
                      />
                      <label htmlFor="checkbox" className="ms-2">
                        Private
                      </label>
                    </div>
                  </Col>

                  {popchecked2 && (
                    <Col lg={6}>
                      <label htmlFor="privateUsers" className="mb-2">User Id's</label>
                      <MultiSelect
                        value={privateDrop}
                        onChange={e => setPrivateDrop(e.value)}
                        options={PrivateDropdownValues}
                        optionLabel="name"
                        optionValue="value"
                        placeholder="Select Users"
                        className="w-full"
                        style={{ border: '1px solid #ced4da' }}
                        display="comma"
                        maxSelectedLabels={3}
                      />
                    </Col>
                  )}
                </Row> */}



                <div className="buttons d-flex justify-content-end  mt-0">
                  <Button
                    type="submit"
                    color="primary"
                    className="btn btn-primary me-2 sidebarbtn"
                  >
                    Create
                  </Button>
                  <Button
                    color="primary"
                    className="btn btn-primary  outlinebtn"
                    // onClick={() => { reset(); setVisibleRight(false) }}
                    onClick={() => {
                      setVisibleRight(false);
                      dispatch({ type: SET_API_STATUS_TRUE });

                      setTimeout(() => {
                        dispatch({ type: SET_API_STATUS_FALSE });
                      }, 2000);
                    }}

                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </form>
          </Sidebar>
        </Col>
      </Row>
      {/* Side bar end */}
    </div>
  )
}

export default WorkTypeSidebar
